import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import React, { ChangeEvent } from 'react'

import { AgentFilter } from './Filters/AgentFilter'
import { DateFilter } from './Filters/DateFilter'
import { DisplayCityFilter } from './Filters/DisplayCityFilter'
import { LengthOfStayFilter } from './Filters/LengthOfStayFilter'
import { MoveInWithinDaysFilter } from './Filters/MoveInWithinDaysFilter'
import { StatusFilter } from './Filters/StatusFilter'
import { TypeFilter } from './Filters/TypeFilter'

type Props = {}

export const FilterBar = ({}: Props) => {
  const { searchString, setSearchString } = usePotentialBookingFiltersContext()

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }
  return (
    <div className="flex flex-col items-center pb-6 md:flex-row-reverse md:justify-end lg:flex-row">
      <div className="mr-2 flex w-full flex-row items-center gap-2 md:mr-4 md:justify-end md:gap-3 lg:flex-wrap">
        <DisplayCityFilter />
        <StatusFilter />
        <AgentFilter />
        <MoveInWithinDaysFilter />
        <LengthOfStayFilter />
        <DateFilter />
        <TypeFilter />
      </div>

      <input
        autoComplete="off"
        className="my-2 w-full flex-1 rounded-lg border-2 border-border-secondary p-2 focus:outline-none md:my-0 md:w-auto md:flex-0"
        onChange={handleSearch}
        placeholder="Search"
        value={searchString || ''}
      />
    </div>
  )
}
